import { React } from 'libs/react';
import './TableCard.scss';
import { useHistory } from 'react-router-dom';
/**
 * @component TableCard
 * @since 1.0.0
 */
export function TableCard(props) {
    const { value, schema } = props;
    const history = useHistory();
    const columnKeys = Object.keys(schema);
    const imageKey = columnKeys.find((key) => { var _a, _b; return ((_a = schema[key]) === null || _a === void 0 ? void 0 : _a.column) === 'icon' || ((_b = schema[key]) === null || _b === void 0 ? void 0 : _b.column) === 'image'; });
    const imageColumn = imageKey ? schema[imageKey] : undefined;
    const actionKey = columnKeys.find((key) => { var _a; return !((_a = schema[key]) === null || _a === void 0 ? void 0 : _a.column); });
    const actionColumn = actionKey ? schema[actionKey] : undefined;
    const onCardClick = () => {
        var _a;
        const defaultAction = (_a = schema['@']) === null || _a === void 0 ? void 0 : _a.render(value);
        if (defaultAction) {
            history.push(defaultAction);
        }
    };
    return (React.createElement("div", { className: "table-card-container", onClick: onCardClick },
        React.createElement("div", { className: "table-card-top-container" },
            React.createElement("div", { className: "table-card-container-infos is-image" },
                React.createElement("div", { className: "table-card-text-infos" }, imageColumn === null || imageColumn === void 0 ? void 0 : imageColumn.render(value))),
            React.createElement("div", { className: "table-card-container-content" }, columnKeys === null || columnKeys === void 0 ? void 0 : columnKeys.map((key) => {
                const column = schema[key];
                const isImage = (column === null || column === void 0 ? void 0 : column.column) == 'image' || (column === null || column === void 0 ? void 0 : column.column) == 'icon';
                const isAction = !(column === null || column === void 0 ? void 0 : column.column);
                if (key === '@' || isImage || isAction) {
                    return null;
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "table-card-container-infos is-text" },
                        !(column === null || column === void 0 ? void 0 : column.hideLabelInCard) && (React.createElement("div", { className: "table-card-title-infos" },
                            "\u00A0",
                            `${column === null || column === void 0 ? void 0 : column.header}`)),
                        React.createElement("div", { className: "table-card-text-infos" }, column === null || column === void 0 ? void 0 : column.render(value)))));
            }))),
        React.createElement("div", { className: "table-card-container-infos is-action" },
            React.createElement("div", { className: "table-card-text-infos" }, actionColumn === null || actionColumn === void 0 ? void 0 : actionColumn.render(value)))));
}
